export enum EHeaderShopCampaignData {
    BACKBUTTON = "backButton",
    HEADLINE = "headline",
    SUBTITLE = "subtitle",
    SELECTIONLABEL = "selectionLabel",
    CUSTOMERDATAPATH = "customerDataCampaignOrder.headerShopCampaign",
    ENDPAGEPATH = "endPageCampaignOrder"
}